export default __webpack_public_path__ + "static/media/assistant22.1ac78722.png";